import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';

/** Text from ErrorEvent or PromiseRejectionEvent for matching transport failures */
function collectTransportErrorText(event) {
  const err =
    event && typeof event === 'object' && 'reason' in event
      ? event.reason
      : event && 'error' in event
        ? event.error
        : null;
  const parts = [
    event && event.message,
    err && typeof err === 'object' && err.message,
    err && typeof err === 'object' && err.stack,
    typeof err === 'string' ? err : '',
    err != null && String(err),
  ].filter(Boolean);
  return parts.join('\n').toLowerCase();
}

function isSocketTransportDevNoise(event) {
  const t = collectTransportErrorText(event);
  return (
    t.includes('xhr poll error') ||
    t.includes('xhr post error') ||
    t.includes('websocket error') ||
    t.includes('transport error') ||
    (t.includes('transport') && t.includes('onerror'))
  );
}

function tryDismissCraRuntimeOverlay() {
  if (process.env.NODE_ENV !== 'development') return;
  try {
    const reo = require('react-error-overlay');
    if (reo && typeof reo.dismissRuntimeErrors === 'function') {
      reo.dismissRuntimeErrors();
    }
  } catch (_) {
    /* optional dep / production */
  }
}

// Socket.io engine errors are expected when dispatch is down; CRA's react-error-overlay
// registers before app code — preventDefault is not enough, so dismiss the overlay explicitly.
function handleSocketTransportOverlay(event) {
  if (!isSocketTransportDevNoise(event)) return;
  if (event.preventDefault) event.preventDefault();
  tryDismissCraRuntimeOverlay();
  setTimeout(() => tryDismissCraRuntimeOverlay(), 0);
}

window.addEventListener('error', handleSocketTransportOverlay, true);
window.addEventListener('unhandledrejection', handleSocketTransportOverlay, true);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);